import { useEffect } from 'react';
import '@aws-amplify/ui-react/styles.css';
import '../PrivacyPolicy.css';

export default function Tos() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <div id="privacypolicy-home">
        <div
          id="terms_of_service"
          name="termly-embed"
          data-id={process.env.REACT_APP_TERMLY_TERMS_OF_SERVICE}
          data-type="iframe"
        ></div>
      </div>
    </>
  );
}
